<template>
    <button v-if="!href && !route" @click="onClick" :class="btnClass" :disabled="disabled">
        <slot />
    </button>
    <button v-else-if="disabled && (href || route)" :class="btnClass" :disabled="disabled">
        <slot />
    </button>
    <router-link v-else-if="!href && route" :class="btnClass" :to="route">
        <span @click="onClick">
            <slot />
        </span>
    </router-link>
    <a v-else-if="href && target !== 'internal'" :href="href" :target="target" :class="btnClass" @click="onClick">
        <slot />
    </a>
	<a v-else-if="href" :href="href" :class="btnClass" @click="onClick">
		<slot />
	</a>
</template>

<script>
    export default {
        name: "globalButton",
		props: {
        	icon: {
        		type: String,
        		default: ''
			},
            theme: {
				type: String,
				default: 'primary',
				validator: function (value) {
					return ['primary', 'secondary', 'brand', 'ghost'].indexOf(value) !== -1
				}
			},
			opacity: {
				type: String,
				default: 'full',
				validator: function (value) {
					return ['full', 'half'].indexOf(value) !== -1
				}
			},
            target: {
        	    type: String,
                default: '_blank',
                // Disabled, weil die Beschränkung auf internal und _blank irgendwie willkürlich ist? im solutionguide benutze ich z.B. "bookingmodal" für sal-bookingmodal.js :-o
                // validator: function (value) {
                //     return ['internal', '_blank'].indexOf(value) !== -1
                // }
            },
            route: {
            },
			href: {
                type: String
			},
            disabled: {
        	    type: Boolean,
                default: false
            }
		},
		computed: {
			btnClass: function() {
                let btnClass = 'button';
                if (this.theme) {
                    btnClass += ' button--' + this.theme;

                    if (this.opacity === 'half') {
                        btnClass += ' button--opacity';
                    }
                }
                if (this.icon) {
                    if (!(!!this.$slots.default || !!this.$scopedSlots.default)) {
                        btnClass += ' button--icon'; // Only icon not content
                    }
                    btnClass += ' icon--before icon--' + this.icon;
                }

                return btnClass;
			}
		},
		methods: {
        	onClick: function(event) {
        		this.$emit('click', event);
			}
		}
    }
</script>
